import config from "config/config";
import { v4 as uuidv4 } from "uuid";
import { Link } from "react-router-dom";
import Countdown from "react-countdown";
import { useForm } from "react-hook-form";
import { Dialog } from "@headlessui/react";
import { useEffect, useState } from "react";
import { useTranslation, Trans } from "react-i18next";

import DialogBackdrop from "./DialogBackdrop";
import FormInputError from "components/General/FormInputError";
import EverlakeLoadingOverlay from "components/General/EverlakeLoadingOverlay";

import { sendEmailNotification } from "service/notificationservice/sendEmailNotification";

export default function LoginOTPModal({
  dialogState,
  setDialogState,
  loginOTP,
  setloginOTP,
  onSubmitOTP,
  userEmail,
  loginType,
}) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [enteredOTPError, setenteredOTPError] = useState("");
  const uuid = uuidv4();
  const [currentCounterTime, setCurrentCounterTime] = useState(
    Date.now() + parseInt(config.OTP_EXPIRY_TIME)
  );
  const [passcodeExpired, setPasscodeExpired] = useState(false);
  const [currentCounterIndex, setCurrentCounterIndex] = useState(0);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset: resetLoginOTPForm,
  } = useForm();

  useEffect(() => {
    setCurrentCounterTime(Date.now() + parseInt(config.OTP_EXPIRY_TIME));
    setCurrentCounterIndex(currentCounterIndex + 1);
  }, [loginOTP]);

  function randomNumberInRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const renderer = ({ minutes, seconds, completed }) => {
    if (completed) {
      setPasscodeExpired(true);
      return (
        <Link
          to=""
          className="mb-4 mr-5"
          onClick={async () => {
            let passcode = randomNumberInRange(100000, 999999);
            setloginOTP(passcode.toString());
            setLoading(true);
            let securitycode = randomNumberInRange(100000, 999999);
            let sec =
              parseInt(securitycode.toString().substring(3, 4)) === 0
                ? 1
                : parseInt(securitycode.toString().substring(3, 4));
            let confirmationcode = passcode * sec;

            let contentDictionary = {};
            contentDictionary.confirmationcode = confirmationcode.toString();
            contentDictionary.securitycode = securitycode.toString();
            loginType === "agent"
              ? await sendEmailNotification(
                  userEmail,
                  12,
                  contentDictionary
                ).catch((error) => {
                  console.log(error);
                })
              : await sendEmailNotification(
                  userEmail,
                  2,
                  contentDictionary
                ).catch((error) => {
                  console.log(error);
                });

            setLoading(false);
            setCurrentCounterTime(
              Date.now() + parseInt(config.OTP_EXPIRY_TIME)
            );
            setCurrentCounterIndex(currentCounterIndex + 1);
            setPasscodeExpired(false);
          }}
        >
          Resend Code
        </Link>
      );
    } else {
      return (
        <p className="text-sm">
          Code expires in {minutes > 9 ? minutes : "0" + minutes}:
          {seconds > 9 ? seconds : "0" + seconds}
        </p>
      );
    }
  };

  async function submitOTP(data) {
    if (passcodeExpired) {
      setenteredOTPError("The code has now expired. Please click Resend Code.");
    } else {
      if (
        data.loginConfirmationCode === loginOTP ||
        (config.ENABLE_DEFAULT_OTP === "true" &&
          data.loginConfirmationCode === config.DEFAULT_OTP)
      ) {
        setenteredOTPError("");
        resetLoginOTPForm();
        onSubmitOTP();
      } else {
        setenteredOTPError(
          "The code verification you entered has failed. Please check again and enter the code received in your email."
        );
      }
    }
  }

  return (
    <EverlakeLoadingOverlay isLoading={loading}>
      <Dialog open={dialogState} onClose={() => null} className="ui-dialogs">
        <DialogBackdrop />

        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Dialog.Panel
            role="dialog"
            aria-modal="true"
            className="ui-default-dialog"
          >
            <Dialog.Title className="font-body text-xl font-bold text-left">
              {t("LoginOTP-title")}
            </Dialog.Title>
            <hr />
            <form onSubmit={handleSubmit(submitOTP)}>
              <div className="ui-dialog-body">
                <p className="text-sm">
                  <Trans defaults={"LoginOTP-subtitle"} />
                </p>
                <div className="mt-4">
                  <label id={`${uuid}-confirmationCodeLabel`}>
                    {t("LoginOTP-modalLabel")}
                  </label>
                  <input
                    id="ID_confirmationCode"
                    className="w-full"
                    type="text"
                    aria-describedby={`${uuid}-registrationConfirmationCodeError`}
                    aria-labelledby={`${uuid}-confirmationCodeLabel`}
                    {...register("loginConfirmationCode", {
                      required: {
                        value: true,
                        message: "please enter your code",
                      },
                      pattern: {
                        value: /^\d{6}$/,
                        message: "Please enter a valid code (6 digits)",
                      },
                    })}
                  />
                  {errors.loginConfirmationCode && (
                    <FormInputError
                      id={`${uuid}-registrationConfirmationCodeError`}
                      errorMessage={errors.loginConfirmationCode.message}
                    />
                  )}
                  {enteredOTPError && (
                    <FormInputError
                      id={`${uuid}-registrationConfirmationCodeError`}
                      errorMessage={enteredOTPError}
                    />
                  )}
                </div>
                <div className="mt-4 md:mt-6">
                  <Countdown
                    date={currentCounterTime}
                    key={currentCounterIndex}
                    renderer={renderer}
                  />
                </div>
              </div>
              <div className="block text-right mt-6">
                <button
                  type="button"
                  className="ui-btn-secondary ui-btn-min-w mt-4"
                  onClick={() => {
                    resetLoginOTPForm();
                    setenteredOTPError("");
                    setDialogState(false);
                  }}
                >
                  {t("LoginOTP-close")}
                </button>
                <button className="ui-btn-primary ui-btn-min-w mt-4">
                  {t("LoginOTP-submit")}
                </button>
              </div>
            </form>
          </Dialog.Panel>
        </div>
      </Dialog>
    </EverlakeLoadingOverlay>
  );
}
